import VueRouter from 'vue-router'
import {SecureGuard} from "./guards/AuthenticationGuard";
//
import Profil from './components/pages/category/Profil'
import LoginForget from './components/pages/LoginForget'
import Notifications from './components/pages/category/Notifications'
//
import ChallengesHome from './components/pages/sub_category/challenges/ChallengesHome'
import ChallengesMessagerie from './components/pages/sub_category/challenges/ChallengesMessagerie'
import ChallengesMessagerieContact from './components/pages/sub_category/challenges/ChallengesMessagerieContact'
import ChallengesMobile from './components/pages/sub_category/challenges/ChallengesMobile'
import ChallengesConcours from './components/pages/sub_category/challenges/ChallengesConcours'
import ChallengesCommercials from './components/pages/sub_category/challenges/ChallengesCommercials'
import ChallengesNews from './components/pages/sub_category/challenges/ChallengesNews'
import LoginReset from "@/components/pages/LoginReset";
import ExportsHome from "@/components/pages/sub_category/export/ExportsHome.vue";


//

export const router = new VueRouter({
  base: '/',
  mode: 'history',
  routes: [
    { path: "*",
      component: () =>
          import("@/components/pages/404"),
    },
    { path: "/no_access",
      component: () =>
          import("@/components/pages/no_access"),
    },
    { path: "/global_no_access",
      component: () =>
          import("@/components/pages/global_no_access"),
    },
    {
      path: "/",
      name: "home",
      redirect: "/resume"
    },
    {
      path: "/admin/:pathMatch(.*)*",
      redirect: "/"
    },
    {
      path: "/auth/login",
      name: "login",
      component: () =>
          import("@/components/pages/LoginPage"),
      children: [
        {
          path: "password",
          name:"forget-password",
          components:{
            default:LoginForget,
          },
        },
        {
          path: "reset-password",
          name:"reset-password",
          components:{
            default:LoginReset,
          },
        }
      ]
    },
    {
      path: "/",
      name: "admin",
      beforeEnter : SecureGuard,
      component: () =>
          import("@/components/pages/Admin"),
      children:[
        {
          path: "profile",
          components:{
            slideOut:Profil,
          },
          children:[
            {
              path: "/",
              name: "profileHome",
              component: () =>
                  import(/* webpackChunkName: "profileHome" */ "@/components/pages/sub_category/profile/ProfileHome"),
              meta: {
                bodyClass: 'profile',
              },
              children:[
                {
                  path: "collaborateur",
                  name: "profileCollab",
                  component: () =>
                      import(/* webpackChunkName: "ProfileCollab" */ "@/components/pages/sub_category/profile/ProfileCollab"),
                  meta: {
                    bodyClass: 'profile',
                  },
                  children:[
                    {
                      path: "ajouter",
                      name: "profileCollabAdd",
                      component: () =>
                          // import(/* webpackChunkName: "FormCollab" */ "@/components/pages/sub_category/profile/FormCollab"),
                          import(/* webpackChunkName: "FormCollab" */ "@/components/module/modal/FormCollab"),
                      meta: {
                        bodyClass: 'profile',
                      },
                    }
                  ]
                },
              ]
            },
          ]
        },
        {
          path: "notifications",
          components:{
            slideOut:Notifications,
          },
          children:[
            {
              path: "/",
              name: "notificationsHome",
              component: () =>
                  import(/* webpackChunkName: "notificationsHome" */ "@/components/pages/sub_category/notifications/NotificationsHome"),
              meta: {
                bodyClass: 'notifications',
              },
            },
          ]
        },
        {
          path: "parcourir",
          beforeEnter : SecureGuard,
          meta: {
            bodyClass: 'browse'
          },
          component: () =>
              import(/* webpackChunkName: "browse" */ "@/components/pages/category/Browse"),
          children:[
            {
              path: "/",
              name: "browseHome",
              component: () =>
                  import(/* webpackChunkName: "browseHome" */ "@/components/pages/sub_category/browse/BrowseHome"),
              meta: {
                bodyClass: 'browse',
              }
            }
          ]
        },
        {
          path: "resume",
          beforeEnter : SecureGuard,
          component: () =>
              import(/* webpackChunkName: "resume" */ "@/components/pages/category/Resume"),
          children:[
            {
              path: "/",
              name: "resume_home",
              component: () =>
                  import(/* webpackChunkName: "resumeHome" */ "@/components/pages/sub_category/resume/ResumeHome"),
              meta: {
                bodyClass: 'resume',
              },
            },
          ]
        },
        {
          path: "challenges",
          beforeEnter : SecureGuard,
          component: () =>
              import(/* webpackChunkName: "challenges" */ "@/components/pages/category/Challenges"),
          // meta: {
          //   bodyClass: 'parent-home',
          // },
          children:[
            {
              path: "/",
              name: "challengesHome",
              components:{
                default:ChallengesHome,
              },
              meta: {
                bodyClass: 'challenges-home',
              },
              children:[
                {
                  path: "concours",
                  name: "challenges-concours",
                  meta: {bodyClass: 'concours'},
                  components:{
                    default: ChallengesConcours
                  },
                },
                {
                  path: "commercials",
                  name: "challenges-commercials",
                  meta: {bodyClass: 'concours'},
                  components:{
                    default: ChallengesCommercials
                  },
                },
                {
                  path: "messagerie/",
                  name: "challenges-messagerie",
                  meta: {bodyClass: 'challenges'},
                  components:{
                    default: ChallengesMessagerie
                  },
                  children:[
                    {
                      path: "contact",
                      name: "challenges-messagerie-contact",
                      meta: {bodyClass: 'challenges'},
                      components:{
                        helper: ChallengesMessagerieContact
                      },
                    }
                  ]
                },
                {
                  path: "accueil",
                  name: "challenges-accueil",
                  component: () =>
                      import(/* webpackChunkName: "challengesAccueil" */ "@/components/pages/sub_category/challenges/ChallengesAccueil"),
                  meta: {
                    bodyClass: 'challenges',
                  },
                  children:[
                    {
                      path: "news/:userId",
                      name: "desc-news",
                      meta: {bodyClass: 'challenges'},
                      components:{
                        default: ChallengesNews
                      },
                    }
                  ]
                },
                {
                  path: "mobile-challenges",
                  name: "mobile-challenges-all",
                  components:{
                    default:ChallengesConcours,
                  },
                  meta: {
                    bodyClass: 'challenges',
                  },
                  children: [
                    // {
                    //   path: "contact",
                    //   name: "challenges-messagerie-contact-mobile",
                    //   meta: {bodyClass: 'challenges'},
                    //   components:{
                    //     default:ChallengesMobile,
                    //     addContact: ChallengesMessagerieContact
                    //   },
                    // },
                  ]
                },
                {
                  path: "mobile",
                  name: "mobile",
                  components:{
                    default:ChallengesMobile,
                  },
                  meta: {
                    bodyClass: 'challenges',
                  },
                  children: [
                    {
                      path: "contact",
                      name: "challenges-messagerie-contact-mobile",
                      meta: {bodyClass: 'challenges'},
                      components:{
                        default:ChallengesMobile,
                        addContact: ChallengesMessagerieContact
                      },
                    },
                    {
                      path: "news/:userId",
                      name: "desc-news-mobile",
                      meta: {bodyClass: 'challenges'},
                      components:{
                        modal: ChallengesNews
                      },
                    }
                  ]
                },

                {
                  path: "excursions",
                  name: "challenges-excursions",
                  component: () =>
                      import(/* webpackChunkName: "challengesExcursions" */ "@/components/pages/sub_category/challenges/ChallengesExcursions"),
                  meta: {
                    bodyClass: 'challenges',
                  }
                },
                {
                  path: "challenges-commerciaux",
                  name: "challenges-commerciaux",
                  component: () =>
                      import(/* webpackChunkName: "challengesCommerciaux" */ "@/components/pages/sub_category/challenges/ChallengesCommerciaux"),
                  meta: {
                    bodyClass: 'challenges',
                  }
                },
                {
                  path: "classement",
                  name: "challenges-classement",
                  component: () =>
                      import(/* webpackChunkName: "challengesClassement" */ "@/components/pages/sub_category/challenges/ChallengesClassement"),
                  meta: {
                    bodyClass: 'challenges',
                  }
                },
                {
                  path: "destinations",
                  name: "challenges-destinations",
                  component: () =>
                      import(/* webpackChunkName: "challengesDestinations" */ "@/components/pages/sub_category/challenges/ChallengesDestinations"),
                  meta: {
                    bodyClass: 'challenges',
                  }
                },
              ]
            },

          ]
        },
        {
          path: "exports",
          beforeEnter : SecureGuard,
          component: () =>
              import("@/components/pages/category/Exports"),
          children:[
            {
              path: "/",
              name: "exportsHome",
              components:{
                default:ExportsHome,
              },
              meta: {
                bodyClass: 'exports',
              },
              children: [
              ]
            },

          ]
        },
        {
          path: "pro",
          beforeEnter : SecureGuard,
          meta: {
            bodyClass: 'pro'
          },
          component: () =>
              import("@/components/pages/category/Pro"),
          children:[
            {
              path: "/",
              name: "pro_home",
              component: () =>
                  import("@/components/pages/sub_category/pro/ProHome"),
              meta: {
                bodyClass: 'pro',
              }
            }
          ]
        },
        {
          path: "commerciaux",
          beforeEnter : SecureGuard,
          // name: "commercials",
          // beforeEnter : SecureGuard,
          meta: {
            bodyClass: 'commercials'
          },
          component: () =>
              import(/* webpackChunkName: "commercials" */ "@/components/pages/category/Commercials"),
          children:[
            {
              path: "/",
              name: "commercials_home",
              component: () =>
                  import(/* webpackChunkName: "commercialsHome" */ "@/components/pages/sub_category/commercials/CommercialsHome"),
              meta: {
                bodyClass: 'commercials',
              },
              children:[
                {
                  path: "commercial/:userId",
                  name: "commercial",
                  component: () =>
                      import(/* webpackChunkName: "commercial" */ "@/components/pages/sub_category/commercials/Commercial"),
                  meta: {
                    bodyClass: 'commercial',
                  },
                },
              ]
            },
          ]
        }
      ]
    },

  ],
  scrollBehavior (to, from, savedPosition) {
    // console.info(savedPosition) // first attemp undefined and next  always {x: 0, y: 0} regardless previous position
    if (savedPosition) {
      return savedPosition
    } else if (to.name == from.name)
    {
      return
    }
    else {
      return { x: 0, y: 0 }
    }
  }
});


router.beforeEach((to, from, next) => {
  const body = document.querySelector('body');
  let el = document.querySelector('ion-content');
  el &&
  el.scrollTo(0, 0);

  if(to.meta.bodyClass){
    body.classList.add(to.meta.bodyClass);
  }
  next();
});
